import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface PlatformMetrics {
  tenants: number;
  modulesActive: number;
  mrrEstimated: number;
  currency: string;
  subscriptionsByStatus: Record<string, number>;
}

export function useMetrics() {
  return useQuery({
    queryKey: ['metrics'],
    queryFn: async () => (await apiClient.get<PlatformMetrics>('/admin/metrics')).data,
    retry: false,
  });
}
